// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"StartupMain_mainContainer__107eB","aboutContainer":"StartupMain_aboutContainer__1Khg3","title":"StartupMain_title__jQn9-","text":"StartupMain_text__1FkW9"};